import { useRouter } from 'next/router';
import styles from '@features/footer/components/LanguageSelect/LanguageSelect.styles';
import { IRegionDataLanguage } from '@typescript/index';
import { useRegionsStore } from '@features/footer/components/LanguageSelect/mobX/context/RegionStoreProvider';
type PropsType = {
  availableLanguages: Array<IRegionDataLanguage>;
  onClose: () => void;
};
const LanguageDropdown = ({
  availableLanguages,
  onClose
}: PropsType) => {
  const router = useRouter();
  const {
    setExternalLanguage
  } = useRegionsStore();
  const changeLocale = async (language: IRegionDataLanguage) => {
    onClose();
    if (router.locale !== language.locale) {
      await setExternalLanguage(language);
      router.push('/', '/', {
        locale: language.locale
      });
    }
  };
  return <div sx={styles.languageDropdown}>
      {availableLanguages.map(language => <button type="button" sx={styles.dropdownListItem} key={`${language.code}-${Math.random()}`} onClick={() => changeLocale(language)}>
          {language.name}
        </button>)}
    </div>;
};
export default LanguageDropdown;